import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNotificationsSnackbar } from '@/components/snackbar/NotificationsSnackbarContext';
import { Box, Grid } from '@mui/material';
import { InputText } from '@/components/shared/InputText';
import { PrimaryButtonStyle, SecondaryButtonStyle } from '../IntegrationDialog';
import { useAppDispatch } from '@/lib/hooks';
import { setLoader } from '@/lib/slices/globalLoaderSlice';
import { usePaymentsMutations } from '@/services/paymentsMutations';

interface DataLonSetupRequest {
    instaPaidServiceFeeCode?: string;
    instaPaidSalaryRecordCode?: string;
    instaPaidTipsRecordCode?: string;
}

interface DataLonConnectProps {
    onClose?: () => void;
    onSaveSuccess: any;
}

export const DataLonConnect = (props: DataLonConnectProps) => {
    const { t } = useTranslation();
    const [dataLonData, setDataLonData] = useState<DataLonSetupRequest>({});
    const { setAlert } = useNotificationsSnackbar();

    const { setupDataLon } = usePaymentsMutations();

    const dispatch = useAppDispatch();

    const onClick = () => {
        setupDataLon.mutate({
            instaPaidServiceFeeCode: dataLonData?.instaPaidServiceFeeCode,
            instaPaidSalaryRecordCode: dataLonData?.instaPaidSalaryRecordCode,
            instaPaidTipsRecordCode: dataLonData?.instaPaidTipsRecordCode
        });
    };

    useEffect(() => {
        if (setupDataLon.isSuccess) {
            props.onSaveSuccess();
        }
    }, [setupDataLon.isSuccess]);

    useEffect(() => {
        if (setupDataLon.isError) {
            setAlert('Connection failed', 'error');
        }
    }, [setupDataLon.isError]);

    useEffect(() => {
        dispatch(setLoader(setupDataLon.isPending));
    }, [setupDataLon.isPending]);

    return (
        <>
            <Box width={'100%'} margin={'20px 0 10px'}>
                <InputText
                    value={dataLonData?.instaPaidServiceFeeCode}
                    label={t('instapaid_service_fee_code')}
                    placeholder={t('')}
                    onChange={(val: any) => {
                        setDataLonData({
                            ...dataLonData,
                            instaPaidServiceFeeCode: val.target.value
                        });
                    }}
                    spacing="10px 0"
                />

                <InputText
                    value={dataLonData?.instaPaidSalaryRecordCode}
                    label={t('instapaid_salary_record_code')}
                    placeholder={t('')}
                    onChange={(val: any) => {
                        setDataLonData({
                            ...dataLonData,
                            instaPaidSalaryRecordCode: val.target.value
                        });
                    }}
                    spacing="10px 0"
                />

                <InputText
                    value={dataLonData?.instaPaidTipsRecordCode}
                    label={t('instapaid_tips_record_code')}
                    placeholder={t('')}
                    onChange={(val: any) => {
                        setDataLonData({
                            ...dataLonData,
                            instaPaidTipsRecordCode: val.target.value
                        });
                    }}
                    spacing="10px 0"
                />
            </Box>

            <Grid m={'20px 0'} container justifyContent={'space-around'}>
                <SecondaryButtonStyle
                    onClick={() => {
                        props.onClose?.();
                    }}
                    sx={{ width: '170px' }}
                >
                    {t('cancel')}
                </SecondaryButtonStyle>

                <PrimaryButtonStyle
                    onClick={onClick}
                    sx={{ width: '170px' }}
                    loading={setupDataLon.isPending}
                    disabled={
                        !dataLonData.instaPaidSalaryRecordCode ||
                        !dataLonData.instaPaidTipsRecordCode
                    }
                >
                    {t('connect')}
                </PrimaryButtonStyle>
            </Grid>
        </>
    );
};
